import { IConsumptions } from "@edp-components/edp-card-widgets/edp-widget-conta-certa/edp-conta-certa.model";
import { Contract } from "@edp-components/edp-contract";
import {
    GetMobieConsumptionsPayload,
    GetStandardConsumptionEvolutionPayload,
    SmartNowConsumptionEvolution,
    SmartNowConsumptionEvolutionValues,
} from "@edp-models/smart-now.model";
import {
    ConsumptionHistory,
    ConsumptionHistoryPayload,
    IConsumptionsChartData,
    IConsumptionsPayload,
    IConsumptionsPeriod,
} from "@edp-models/consumptions.model";
import { Action } from "@ngrx/store";

export enum EConsumptionActions {
    GetConsumptions = "Get Consumptions",
    SetConsumptions = "Set Consumptions",
    ConsumptionsAPIError = "[Consumptions] API error",
    GetConsumptionsChartData = "[Consumptions] Get consumptions chart data",
    SetConsumptionsChartData = "[Consumptions] Set consumptions chart data",
    GetConsumptionsPeriod = "[Consumptions] Get consumptions period",
    SetConsumptionsPeriod = "[Consumptions] Set consumptions period",
    GetConsumptionEvolution = "[Consumptions] Get evolution of consumptions",
    SetConsumptionEvolution = "[Consumptions] Set evolution of consumptions",
    GetConsumptionHistory = "[Consumptions] Get Consumption History",
    SetConsumptionHistory = "[Consumptions] Set Consumption History",
    GetMobieConsumptionHistory = "[Consumptions] Get Mobie Consumption History",
    SetMobieConsumptionHistory = "[Consumptions] Set Mobie Consumption History",
    SetConsumptionSelected = "[Consumptions] Set Consumption Selected",
    GetMobieCardList = "[Consumptions] Get Mobie Card List",
    SetMobieCardList = "[Consumptions] Set Mobie Card List",
    SetActiveTab = "[Consumptions] Set active tab",
    GetMobieConsumptions = "[Consumptions] Get Mobie consumptions",
    SetMobieConsumptions = "[Consumptions] Set Mobie consumptions",
}

export class GetConsumptions implements Action {
    public readonly type = EConsumptionActions.GetConsumptions;
    constructor(public contract: Contract) {}
}

export class SetConsumptions implements Action {
    public readonly type = EConsumptionActions.SetConsumptions;
    constructor(public payload: IConsumptions) {}
}

export class ConsumptionsAPIError implements Action {
    public readonly type = EConsumptionActions.ConsumptionsAPIError;
    constructor(public error: Error) {}
}

export class GetConsumptionsChartData implements Action {
    public readonly type = EConsumptionActions.GetConsumptionsChartData;
    constructor(public payload: IConsumptionsPayload) {}
}

export class SetConsumptionsChartData implements Action {
    public readonly type = EConsumptionActions.SetConsumptionsChartData;
    constructor(public payload: IConsumptionsChartData[]) {}
}

export class GetConsumptionsPeriod implements Action {
    public readonly type = EConsumptionActions.GetConsumptionsPeriod;
    constructor(public payload: IConsumptionsPayload) {}
}

export class SetConsumptionsPeriod implements Action {
    public readonly type = EConsumptionActions.SetConsumptionsPeriod;
    constructor(public payload: IConsumptionsPeriod) {}
}

export class GetConsumptionEvolution implements Action {
    public readonly type = EConsumptionActions.GetConsumptionEvolution;
    constructor(public payload: GetStandardConsumptionEvolutionPayload) {}
}

export class SetConsumptionEvolution implements Action {
    public readonly type = EConsumptionActions.SetConsumptionEvolution;
    constructor(public payload: SmartNowConsumptionEvolution) {}
}

export class GetConsumptionHistory implements Action {
    public readonly type = EConsumptionActions.GetConsumptionHistory;
    constructor(public payload: ConsumptionHistoryPayload) {}
}

export class SetConsumptionHistory implements Action {
    public readonly type = EConsumptionActions.SetConsumptionHistory;
    constructor(public payload: ConsumptionHistory) {}
}

export class GetMobieConsumptionHistory implements Action {
    public readonly type = EConsumptionActions.GetMobieConsumptionHistory;
    constructor(public payload: ConsumptionHistoryPayload) {}
}

export class SetMobieConsumptionHistory implements Action {
    public readonly type = EConsumptionActions.SetMobieConsumptionHistory;
    constructor(public payload: ConsumptionHistory) {}
}

export class SetConsumptionSelected implements Action {
    public readonly type = EConsumptionActions.SetConsumptionSelected;
    constructor(public payload: SmartNowConsumptionEvolutionValues[]) {}
}

export class GetMobieCardList implements Action {
    public readonly type = EConsumptionActions.GetMobieCardList;
    constructor(public payload: IConsumptionsPayload) {}
}

export class SetMobieCardList implements Action {
    public readonly type = EConsumptionActions.SetMobieCardList;
    constructor(public payload: string[]) {}
}

export class GetMobieConsumptions implements Action {
    public readonly type = EConsumptionActions.GetMobieConsumptions;
    constructor(public payload: GetMobieConsumptionsPayload) {}
}

export class SetMobieConsumptions implements Action {
    public readonly type = EConsumptionActions.SetMobieConsumptions;
    constructor(public payload: SmartNowConsumptionEvolution) {}
}

export class SetActiveTab implements Action {
    public readonly type = EConsumptionActions.SetActiveTab;
    constructor(public payload: string) {}
}

export type ConsumptionActions =
    | GetConsumptions
    | SetConsumptions
    | ConsumptionsAPIError
    | GetConsumptionsChartData
    | SetConsumptionsChartData
    | GetConsumptionsPeriod
    | SetConsumptionsPeriod
    | GetConsumptionEvolution
    | SetConsumptionEvolution
    | GetConsumptionHistory
    | SetConsumptionHistory
    | GetMobieConsumptionHistory
    | SetMobieConsumptionHistory
    | SetConsumptionSelected
    | GetMobieCardList
    | SetMobieCardList
    | SetActiveTab
    | GetMobieConsumptions
    | SetMobieConsumptions;
